import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { UploadItemClass } from './UploadItemClass';

export function UploadItem(props) {
    const params = useParams();
    const navigate = useNavigate();

    return (
        <UploadItemClass
            {...props}
            match={{ params }}
            history={{
                push: navigate
            }}
        />
    );
}